
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"24","viewBox":"0 0 16 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.01117 20.163L3.80322 15.7147L5.16534 14.4261L8.00751 17.4307L10.8328 14.428L12.1984 15.7128L8.01117 20.163ZM15.7812 18.375V5.625C15.7812 2.52338 13.2579 0 10.1562 0H5.84375C2.74213 0 0.21875 2.52338 0.21875 5.625V18.375C0.21875 21.4766 2.74213 24 5.84375 24H10.1562C13.2579 24 15.7812 21.4766 15.7812 18.375ZM10.1562 1.875C12.2241 1.875 13.9062 3.55719 13.9062 5.625V18.375C13.9062 20.4428 12.2241 22.125 10.1562 22.125H5.84375C3.77594 22.125 2.09375 20.4428 2.09375 18.375V5.625C2.09375 3.55719 3.77594 1.875 5.84375 1.875H10.1562ZM8 3.79688C7.48218 3.79688 7.0625 4.21655 7.0625 4.73438C7.0625 5.2522 7.48218 5.67188 8 5.67188C8.51782 5.67188 8.9375 5.2522 8.9375 4.73438C8.9375 4.21655 8.51782 3.79688 8 3.79688ZM8 7.54688C7.48218 7.54688 7.0625 7.96655 7.0625 8.48438C7.0625 9.0022 7.48218 9.42188 8 9.42188C8.51782 9.42188 8.9375 9.0022 8.9375 8.48438C8.9375 7.96655 8.51782 7.54688 8 7.54688ZM8 11.2969C7.48218 11.2969 7.0625 11.7166 7.0625 12.2344C7.0625 12.7522 7.48218 13.1719 8 13.1719C8.51782 13.1719 8.9375 12.7522 8.9375 12.2344C8.9375 11.7166 8.51782 11.2969 8 11.2969Z"}})])
          )
        }
      }
    